var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefits2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 9.5,
    r: 5,
    fill: "#059CCC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 9.5,
    r: 5,
    fill: "#059CCC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 9.5,
    r: 5,
    fill: "#41FD90"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 9.5,
    r: 5,
    fill: "#059CCC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9.5,
    r: 5,
    fill: "#059CCC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 33.5,
    r: 3,
    fill: "#2ECA88"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 33.5,
    r: 3,
    fill: "#2ECA88"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 33.5,
    r: 3,
    fill: "#41FD90"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 45.5,
    r: 3,
    fill: "#41FD90"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 33.5,
    r: 3,
    fill: "#2ECA88"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 33.5,
    r: 3,
    fill: "#2ECA88"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 21.5,
    r: 4,
    fill: "#059CCC"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 21.5,
    r: 4,
    fill: "#2ECA88"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 21.5,
    r: 4,
    fill: "#41FD90"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21.5,
    r: 4,
    fill: "#2ECA88"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 21.5,
    r: 4,
    fill: "#059CCC"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 45.5,
    r: 2,
    fill: "#2ECA88"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 45.5,
    r: 2,
    fill: "#2ECA88"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 57.5,
    r: 2,
    fill: "#32E444"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 57.5,
    r: 2,
    fill: "#41FD90"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 45.5,
    r: 2,
    fill: "#2ECA88"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 57.5,
    r: 2,
    fill: "#32E444"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 45.5,
    r: 2,
    fill: "#2ECA88"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 57.5,
    r: 1,
    fill: "#32E444"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 57.5,
    r: 1,
    fill: "#32E444"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits2);
export default __webpack_public_path__ + "static/media/benefits-2.aeb86686dd4db4287a5ad1507337369b.svg";
export { ForwardRef as ReactComponent };